import { isDefined, isNotDefined } from '@sgme/fp';

import { bulkTradeApi } from '@/store/bulkTrade/api';
import { selectBulkTrade } from '@/store/bulkTrade/selectors.ts';
import { subscribeBulkTradeToEsp } from '@/store/bulkTrade/thunks/subscribeBulkTradeToEsp.ts';
import { espStreamUnsubscribed } from '@/store/esp/slice.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { selectTab } from '@/store/tabs/selectors.ts';
import { tabsSlice } from '@/store/tabs/slice.ts';

export const registerChangeClientListenersForBulkTrade = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: tabsSlice.actions.changeClient,
    effect: async (action, api) => {
      const state = api.getState();

      const tab = selectTab(state, action.payload.tabId);
      if (isNotDefined(tab)) {
        return;
      }

      const bulkTrade = selectBulkTrade(state, action.payload.tabId);

      // === UPDATE ESP STREAM

      // stop if there is no bulk trade and no currency pair
      if (isNotDefined(bulkTrade) || isNotDefined(bulkTrade.currencyPair) || bulkTrade.currencyPair === '') {
        return;
      }

      if (isDefined(bulkTrade.tiering)) {
        api.dispatch(
          espStreamUnsubscribed({
            tileId: `${action.payload.tabId}/BULK_TRADE`,
            tiering: bulkTrade.tiering,
            currencyPair: bulkTrade.currencyPair,
          }),
        );
      }

      api.dispatch(subscribeBulkTradeToEsp({ tabId: action.payload.tabId }));

      // === CANCEL RFS

      if (bulkTrade.step !== 'priced' || isNotDefined(bulkTrade.quote?.RfsId)) {
        return;
      }

      api.dispatch(
        bulkTradeApi.endpoints.cancelBulkTradeRfs.initiate({
          tabId: action.payload.tabId,
          rfsId: bulkTrade.quote.RfsId,
        }),
      );
    },
  });
};
